/**
 * @name 统一消息窗口
 */
import base from '../../base';
import MessageDrawer from './MessageDrawer';

MessageDrawer.install = function(Vue) {
  //
  Vue.use(base);
  Vue.component(MessageDrawer.name, MessageDrawer);
};

export default MessageDrawer;
